import React from "react";

export default function Book() {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.625 2.875C9.625 1.42578 8.44922 0.25 7 0.25C5.52344 0.25 4.375 1.42578 4.375 2.875C4.375 4.35156 5.52344 5.5 7 5.5C8.44922 5.5 9.625 4.35156 9.625 2.875ZM6.37109 6.86719C4.75781 5.85547 2.13281 5.58203 0.792969 5.52734C0.355469 5.5 0 5.82812 0 6.26562V12.3359C0 12.7461 0.300781 13.0742 0.710938 13.0742C1.91406 13.1562 4.32031 13.375 5.98828 14.2227C6.23438 14.3594 6.5625 14.168 6.5625 13.8945V7.16797C6.5625 7.03125 6.48047 6.92188 6.37109 6.86719ZM13.1797 5.52734C11.8398 5.58203 9.21484 5.85547 7.60156 6.86719C7.49219 6.92188 7.4375 7.05859 7.4375 7.16797V13.8945C7.4375 14.168 7.73828 14.3594 7.98438 14.2227C9.65234 13.375 12.0586 13.1562 13.2617 13.1016C13.6719 13.0742 14 12.7461 14 12.3359V6.26562C14 5.82812 13.6172 5.5 13.1797 5.52734Z"
        fill="currentColor"
      />
    </svg>
  );
}
